import React, { Suspense, lazy } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import './styles/main.scss';

import Loader from './components/common/loader';

const Search = lazy(() => import('./components/search'));
const Chart = lazy(() => import('./components/chart'));
const Checkout = lazy(() => import('./components/checkout'));
const Login = lazy(() => import('./components/login'));
const Account = lazy(() => import('./components/myAccount'));
const Profile = lazy(() => import('./components/profile'));
const CancelBusBooking = lazy(() => import('./components/cancelBusBooking'));
const SelectSeatsTable = lazy(() => import('./components/cancelBusBooking/SelectSeatsTable'));
const BusBooking = lazy(() => import('./components/myAccount/busBooking'))
const ViewBusBooking = lazy(() => import('./components/myAccount/viewBusBooking'))
const cancelledGuest = lazy(() => import('./components/cancelled/cancelGuest'))
const cancelled = lazy(() => import('./components/cancelled'))
const cancelRequest = lazy(()=> import('./components/cancelRequest'))
const modify = lazy(()=>import('./components/modify'))
const editBooking = lazy(()=>import('./components/modify/editBooking'))
const editGuest = lazy(() => import('./components/editGuest'))
const ContactUsPage = lazy(() => import('./components/contactus'));
const BusTimeTableInquiry = lazy(() => import('./components/bustimetableinquiry'));
const BusTimeTableList = lazy(() => import('./components/bustimetableinquiry/BusTimeTableList'));
const ContactUsPageBusStation = lazy(() => import('./components/contactus/BusStation'));
const ContactUsPageBusStationContent = lazy(() => import('./components/contactus/BusStationContent'));
const AboutUsPage = lazy(() => import("./components/aboutus"));
const Privacy = lazy(() => import('./components/privacy'));
const ReservationTerms = lazy(() => import('./components/reservationTerms'));
const GuestUsersTerms = lazy(() => import('./components/guestUsersTerms'));
const BookingCounters = lazy(() => import('./components/bookingCounters'));
const StudentPass = lazy(()=> import('./components/studentPass/StudentPass'));
const LettersAndCirculars = lazy(()=>import('./components/lettersAndCirculars/LettersAndCirculars'));
const SakalaServices = lazy(() => import("./components/sakalaServices/SakalaServices"));
const RefundRulesAndClaims = lazy(() => import("./components/refundRulesAndClaims/RefundRulesAndClaims"));
const PassesAndConcession = lazy(()=>import("./components/passesAndConcession/PassesAndConcession"));
const LuggageRates = lazy(()=>import("./components/luggageRates/LuggageRates"));
const Sitemap = lazy(() => import("./components/sitemap/Sitemap"));
const FeedbackSubmit = lazy(() => import("./components/feedback/FeedbackSubmit"));
const Feedback = lazy(() => import("./components/feedback/Feedback"));
const HelpAndSupport = lazy(() => import("./components/HelpAndSupport"));
const SearchTourBooking = lazy(() => import("./components/search_tour_booking/Index"));

const MonthlyPassBuyNew = lazy(() => import("./components/monthlyPass/MonthlyPassBuyNew"));

const MonthlyPassCheckout = lazy(() => import('./components/monthlyPassCheckout'));


const App = ({ store }) => (
  <Provider store={store}>
    <Router>
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <Switch>
            <Route path="/search/" component={Search} />
            <Route path={["/seatchart/:rsid/:fromCityId/:fromCityName/:toCityId/:toCityName/:departDate/:returnDate/:mode/:token/:page", "/seatchart/:rsid/:fromCityId/:fromCityName/:toCityId/:toCityName/:departDate/:returnDate/:mode/:token"]} component={Chart} />
            <Route path={["/co/exp/:token/:page", "/co/exp/:token"]} component={Checkout} />
            <Route path="/login/" component={Login} />
            <Route path="/account/" component={Account} />
            <Route path="/edit_profile/" component={Profile} />
            <Route path="/bus_booking/" component={BusBooking} />
            <Route path="/bus_booking_view/" component={ViewBusBooking} />
            <Route path="/cancel_bus_booking/" component={CancelBusBooking} />
            <Route path="/select_seats_forcancel/" component={SelectSeatsTable} />
            <Route path="/cancel_guest/" component={cancelledGuest} />
            <Route path="/cancelled/" component={cancelled} />
            <Route path="/cancel_request" component={cancelRequest}/>
            <Route path="/modify/" component={modify} />
            <Route path="/edit_booking/" component={editBooking} />
            <Route path="/edit_guest/" component={editGuest} />
            <Route path = "/contact_us" component = { ContactUsPage } />
            <Route exact path = "/time_table" component = { BusTimeTableInquiry } />
            <Route exact path = "/time_table/result" component = { BusTimeTableList } />
            <Route path = "/contact_us/bus_station" component = { ContactUsPageBusStation } />
            <Route path = "/contact_us/bus_station/bus_station_content" component = { ContactUsPageBusStationContent } />

            <Route path = "/about_us" component = { AboutUsPage } />
            <Route path = "/privacy" component = { Privacy } />
            <Route path = "/reservation-terms" component = { ReservationTerms } />
            <Route path = "/guest-users-terms" component = { GuestUsersTerms } />
            <Route path = "/booking-counters" component = { BookingCounters } />
            <Route path = "/student-pass" component = { StudentPass } />
            <Route path = "/letters-and-circulars" component = { LettersAndCirculars } />
            <Route path = "/sakala-services" component = { SakalaServices } />
            <Route path = "/refund-rules-and-claims" component = { RefundRulesAndClaims } />
            <Route path = "/passes-and-concession" component = { PassesAndConcession } />
            <Route path = "/luggage-rates" component = { LuggageRates } />
            <Route path = "/sitemap" component = { Sitemap } />
            <Route exact path = "/feedback" component = { Feedback } />
            <Route exact path = "/feedback/submit" component = { FeedbackSubmit } />
            <Route exact path = "/help-and-support" component = { HelpAndSupport } />
            
            <Route path="/search_tour_booking/" component={SearchTourBooking} />

            <Route exact path= "/monthly-pass/buy-new" component={MonthlyPassBuyNew} />
            <Route path={["/monthly-pass/exp/:token/:page", "/monthly-pass/exp/:token"]} component={MonthlyPassCheckout} />

            <Route path="/" component={ErrorPage} />
          </Switch>
        </Suspense>
      </ErrorBoundary>
    </Router>
  </Provider>
)

export default App;

class ErrorBoundary extends React.Component {
  constructor() {
    super();
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return <ErrorPage />;
    }

    return this.props.children;
  }
}

const ErrorPage = () => (
  <div className='err-screen'>
    Oops! some error occured!
    <br />
    <br />
    <a href='/' target='_self'>GO TO HOME</a>
  </div>
)